import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';

export default css`
  .hours {
    margin-bottom: 20px;
  }

  .header {
    display: flex;
    margin-bottom: 5px;
  }

  .flex {
    display: flex;
  }

  .today {
    display: flex;
    flex-direction: column;
    font-weight: 600;
    font-size: 16px;
  }

  .full-hours-container {
    margin-left: 34px;
    max-width: 200px;
  }

  .toggle-hours {
    font-size: 15px;
    font-weight: bold;
    letter-spacing: 0.2px;
    color: ${colors.G4};
    text-transform: uppercase;
  }

  .full-hours {
    margin-bottom: 5px;
    border-collapse: initial;
    border-spacing: 0px 4px;
    display: none;
  }

  .full-hours.open {
    display: initial;
  }

  .hidden {
    display: none;
  }

  .title {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    color: ${colors.BLACK};
  }

  button {
    margin: 0;
    padding: 0;
    border: none;
    background: none;
  }

  @media screen and (min-width: ${screen.mdMin}) {
    .hours {
      margin-bottom: 60px;
    }
    .hide-hours {
      display: none;
    }

    .show-hours {
      display: none;
    }

    .full-hours {
      display: initial;
    }
  }
`;
